module.exports = __webpack_public_path__ + "static/media/sf-test-16.8eae9e7d.mp3";